module.exports = __webpack_public_path__ + "static/media/gis3.99b2678c.png";